import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getDevices} from "./DevicesActions";
import Grid from "@material-ui/core/es/Grid";
import CircularProgress from "@material-ui/core/es/CircularProgress";
import {changePageHeader} from "../app/AppActions";
import withStyles from "@material-ui/core/es/styles/withStyles";
import DeviceExpPanel from "./component/DeviceExpPanel";
import typography from "@material-ui/core/es/styles/createTypography";
import grey from '@material-ui/core/colors/grey';
const grey600 = grey['600'];

const styles = theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    devicesList: {
        marginTop: '10px',
        maxWidth: '600px'
    },
    loadingCircleContainer: {
        textAlign: 'center',
        paddingTop: '35px'
    },
    bigClearText: {
        fontSize: 20,
        fontWeight: typography.fontWeightLight,
        color: grey600
    },
});


class Devices extends Component {

    state = {openedListItem: null};

    componentWillMount() {
        const {user} = this.props;
        this.props.getDevices(user.email);
        this.props.changePageHeader('Devices', true);
    }

    handleListItemClick = index => this.setState({openedListItem: this.state.openedListItem === index ? null : index});

    renderDevices = () => {
        const {classes, devices: {fetching, devices}} = this.props;
        if (fetching) {
            return (
                <div className={classes.loadingCircleContainer}>
                    <CircularProgress size={80} thickness={5}/>
                </div>
            );
        } else if (devices.length === 0) {
            return (
                <div className={classes.loadingCircleContainer}>
                    <h4 className={classes.bigClearText}>No devices found</h4>
                </div>
            )
        }
        return (
            <div id='devices'>
                {devices.map((device, index) => {
                    const isOpened = this.state.openedListItem === index;
                    return <DeviceExpPanel isOpened={isOpened} device={device} classes={this.props.classes}
                                           handleListItemClick={this.handleListItemClick} index={index} key={device.device_id}z/>
                })}
            </div>
        );
    };

    render() {
        return (
            <Grid container justify='center'>
                <Grid item xs={12} sm={8} className={this.props.classes.devicesList}>
                    {/*<PageBase navigation="Application / Devices" title="Devices">*/}
                    {this.renderDevices()}
                    {/*</PageBase>*/}
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps({devices, user, brand}) {
    return ({devices, user, brand})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDevices,
        changePageHeader
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Devices));



// WEBPACK FOOTER //
// ./src/containers/devices/Devices.js